import React, { Component } from 'react';

/**
 * ดักจับ error ที่เกิดตอน render หลังแอป mount แล้ว (watchdog ใน template ดักได้เฉพาะช่วง boot)
 * แสดงข้อความ + ปุ่มโหลดใหม่แทนการปล่อยให้ทั้งหน้าพังเป็นจอขาว
 * กรณีปกติจะส่ง children ผ่านเฉยๆ ไม่มีผลกับการทำงานเดิม
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    try {
      if (typeof window.clarity === 'function') window.clarity('event', 'react_render_error');
    } catch (e) {
      // ignore
    }
    // prefix เดียวกับ watchdog ใน template.html เพื่อให้ filter ใน console ด้วยคำเดียวเจอทุกเคส
    console.error('[apple-sure] react_render_error', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: 24,
            // ใช้ font ระบบให้หน้าตาตรงกับหน้า error ของ watchdog ใน template.html ทุกกรณี
            fontFamily: 'sans-serif',
          }}
        >
          <p style={{ margin: '0 0 16px', fontSize: 16, color: '#333' }}>
            กรุณาลองใหม่อีกครั้ง
          </p>
          <button
            style={{
              padding: '10px 24px',
              fontSize: 16,
              border: 0,
              borderRadius: 6,
              background: '#45b4a8',
              color: '#fff',
              cursor: 'pointer',
            }}
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
